import { Icon } from '@aibees/shared/components';
import { Avatar, Box } from '@mui/material';
import React from 'react';
import * as SX from './sx';
import type { TreeItemIconBlockProps } from './types';

function TreeItemIconBlockComponent({
  icon,
  logoUrl,
  iconSx,
  avartarFallbackIcon,
}: TreeItemIconBlockProps) {
  return (
    <>
      {!!icon && (
        <Box display="flex" alignItems="center" justifyContent="center">
          <Icon name={icon} size={20} sxx={iconSx} />
        </Box>
      )}
      {!!logoUrl && (
        <Box sx={SX.iconWrapper}>
          <Avatar src={logoUrl} size={24} color="white" variant="rounded">
            <Icon
              color="grey.400"
              size={12}
              name={avartarFallbackIcon ?? 'business'}
            />
          </Avatar>
        </Box>
      )}
    </>
  );
}

TreeItemIconBlockComponent.displayName = 'TreeItemIconBlock';

export const TreeItemIconBlock = React.memo(TreeItemIconBlockComponent);
